import store from "@/stores";

const can = {
  mounted(el, binding) {
    const allowed = store.getters["role/can"];
    if (!allowed(binding.value)) {
      if (el.parentNode) el.parentNode.removeChild(el);
    }
  },
};

export default can;
